<!--
  @修改人：xiehan
  @修改时间：2019-01-15
  @修改描述：修改所有菜单获取方式---只获取当前用户有权限访问的菜单
  @版本:v2.0.1
  ------------
  @description 菜单管理
  @author xiehan
  @date 2018/12/12
-->
<template>
  <div class="roleManage roleManage__content">
    <g-back :history="history" class="ilb mr-base"></g-back>
    <el-button type="primary"
      @click="saveRole"
      v-text="$t('common.save')"></el-button>
    <el-form ref="handleForm" :model="handleForm" label-width="80px" :rules="rules">
      <el-form-item :label="$t('roleManage.name')" prop="name">
        <el-input v-model="handleForm.name"></el-input>
      </el-form-item>
      <el-form-item :label="$t('roleManage.description')" prop="description">
        <el-input v-model="handleForm.description"></el-input>
      </el-form-item>
      <el-form-item :label="$t('roleManage.enabled')" prop="enabled">
        <el-checkbox v-model="handleForm.enabled">{{ $t('roleManage.yes') }}</el-checkbox>
      </el-form-item>
      <el-form-item :label="$t('roleManage.menuList')">
        <el-button type="text" @click="openMenuListDia">{{ $t('common.chooseTips') }}</el-button>
      </el-form-item>
    </el-form>
    <el-dialog :closeOnClickModal="false"
      :title="$t('roleManage.menuList')"
      :visible.sync="menuListVis"
      width="700px">
      <div style="display: flex">
        <div class="tree-wrap">
          <el-tree
            :data="menuList"
            :check-strictly="true"
            ref="menuListTree"
            show-checkbox
            node-key="id"
            accordion
            highlight-current
            :props="defaultProps"
            @node-click="handleNodeClick">
          </el-tree>
        </div>
        <div class="ilb ml-base check-padding">
          <div v-text="menuTitle"></div>
          <el-checkbox 
            v-model="checkAllBtn"
            @change="handleCheckAllChange"
            v-show="buttonList.length > 0">{{ $t('roleManage.allSelect') }}</el-checkbox>
          <div style="margin: 15px 0;"></div>
          <el-checkbox-group v-model="checkedBtnList" @change="handleCheckedBtnChange">
            <el-checkbox v-for="item in buttonList" :label="item.id" :key="item.id">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="menuListVis = false" v-text="$t('common.close')"></el-button>
        <el-button type="primary" @click="confirmAuth" v-text="$t('common.confirm')"></el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  // import menuManageBiz from '@/logic/systemSetting/menuManageBiz'
  import roleManageBiz from '@/logic/systemSetting/roleManageBiz'
  import MenuBiz from '@/logic/leftMenuBiz'
  export default {
    data () {
      return {
        history: [],
        handleForm: {
          name: '',
          description: '',
          enabled: true
        },
        rules: {
          name: [{ required: true, message: `${this.$t('common.entryTips')}${this.$t('roleManage.name')}` }],
          description: [{ required: true, message: `${this.$t('common.entryTips')}${this.$t('roleManage.description')}` }]
        },
        menuListVis: false,
        menuList: [], // 树节点
        primaryList: [], // 原始数据
        buttonList: [], // 当前按钮列表
        buttonAuthList: [], // 已确定设置按钮权限列表
        checkedBtnList: [], // 当前选择按钮列表
        menuAuthList: [], // 菜单权限列表
        confirmButtonAuthList: [], // 已确定设置按钮权限列表
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        checkAllBtn: false,
        menuTitle: ''
      }
    },
    methods: {
      init () {
        this.setHistory()
        this.getAllList()
      },
      setHistory () {
        this.history = []
        this.history.push({ name: this.$route.query.id
          ? this.$t('roleManage.editRole') : this.$t('roleManage.addRole') })
      },
      getUserAuth (primaryList) {
        if (this.$route.query.id) {
          roleManageBiz.findRoleById({ id: this.$route.query.id }).then(data => {
            for (let i in this.handleForm) {
              this.handleForm[i] = data[i]
            }
            // let tempDeleteList = []
            data.menuList.map(item => {
              if (isNaN(Number(item))) {
                this.confirmButtonAuthList.push(item)
              } else {
                // 判断子页面是否全选
                // let itemIndex = this.primaryList.findIndex(primaryItem => primaryItem.id === item)
                // if (itemIndex >= 0 && (this.primaryList[itemIndex].level === '1' || this.primaryList[itemIndex].level === '2')) {
                //   let allChildInAuth = true
                //   this.primaryList.map(priamryItem => {
                //     if (priamryItem.parentID === this.primaryList[itemIndex].id &&
                //     data.menuList.findIndex(authItem => authItem === priamryItem.id) === -1) {
                //       allChildInAuth = false
                //     }
                //   })
                //   if (allChildInAuth) {
                //     this.menuAuthList.push(item)
                //   } else {
                //     tempDeleteList.push(this.primaryList[itemIndex].parentID)
                //   }
                // } else {
                //   this.menuAuthList.push(item)
                // }
                this.menuAuthList.push(item)
              }
            })
            // 删除子页面没有全选的页面
            // tempDeleteList.map(_item => {
            //   if (this.menuAuthList.findIndex(item => item === _item) > -1) {
            //     this.menuAuthList.splice(this.menuAuthList.findIndex(item => item === _item), 1)
            //   }
            // })
          })
        }
      },
      saveRole () {
        this.$refs['handleForm'].validate((valid) => {
          if (valid) {
            let saveObj = {
              menuList: [ ...this.menuAuthList, ...this.confirmButtonAuthList ],
              ...this.handleForm
            }
            let evnetName = this.$route.query.id ? 'amendRole' : 'addRole'
            if (this.$route.query.id) saveObj.id = this.$route.query.id
            roleManageBiz[evnetName](saveObj).then(data => {
              this.$message({
                message: this.$t('common.success'),
                type: 'success'
              })
              this.$router.push({ name: 'roleManage' })
            })
          } else {
            return false
          }
        })
      },
      openMenuListDia () {
        this.menuListVis = true
        this.menuTitle = ''
        this.buttonAuthList = [ ...this.confirmButtonAuthList ]
        this.buttonList = []
        this.$nextTick(() => {
          this.$refs.menuListTree.setCheckedKeys(this.menuAuthList)
        })
      },
      confirmAuth () {
        this.menuListVis = false
        this.menuAuthList = this.$refs.menuListTree.getCheckedKeys()
        // 当子菜单有权限时 父菜单也要相应添加权限
        // this.menuAuthList.map(item => {
        //   let parentID = this.primaryList.find(_item => _item.id === item).parentID
        //   if (this.menuAuthList.findIndex(_item => _item === parentID) < 0) {
        //     this.menuAuthList.push(parentID)
        //   }
        // })
        this.confirmButtonAuthList = [ ...this.buttonAuthList ]
      },
      getAllList () {
        MenuBiz.getMenuAndButton().then((data) => {
          this.primaryList = data
          let firstList = data.filter(item => item.type === 'MENU' && item.level === '1')
          let secondList = data.filter(item => item.type === 'MENU' && item.level === '2')
          let thirdList = data.filter(item => item.type === 'MENU' && item.level === '3')
          this.setChildrenList(secondList, thirdList)
          this.setChildrenList(firstList, secondList)
          this.setMenuList(firstList)
          this.getUserAuth(firstList)
        })
        // menuManageBiz.getAll().then(data => {
        //   this.primaryList = data
        //   let firstList = data.filter(item => item.type === 'MENU' && item.level === '1')
        //   let secondList = data.filter(item => item.type === 'MENU' && item.level === '2')
        //   let thirdList = data.filter(item => item.type === 'MENU' && item.level === '3')
        //   this.setChildrenList(secondList, thirdList)
        //   this.setChildrenList(firstList, secondList)
        //   this.setMenuList(firstList)
        //   this.getUserAuth(firstList)
        // })
      },
      setMenuList (list) {
        this.menuList = []
        this.sortList(list).map(item => {
          this.menuList.push({
            label: item.name,
            value: item.id,
            children: item.children,
            ...item
          })
        })
      },
      setChildrenList (parents, children) {
        parents.map(pItem => {
          pItem.children = []
          children.map(cItem => {
            if (pItem.id === cItem.parentID) {
              let obj = {
                label: cItem.name,
                value: cItem.id,
                ...cItem
              }
              obj.children = cItem.children
              pItem.children.push(obj)
            }
          })
          this.sortList(pItem.children)
        })
      },
      sortList (arr) {
        return arr.sort((a, b) => {
          return Number(a.sortIndex) - Number(b.sortIndex)
        })
      },
      handleCheckAllChange (val) {
        this.checkedBtnList = val ? this.buttonList.map(item => item.id) : []
        this.clearCurrentAuth()
        if (val) {
          this.checkedBtnList.map(item => this.buttonAuthList.push(item))
        }
      },
      clearCurrentAuth () {
        if (this.buttonList.length === 0) return
        this.buttonList.map(item => {
          let index = this.buttonAuthList.findIndex(_item => _item === item.id)
          if (index >= 0) this.buttonAuthList.splice(index, 1)
        })
      },
      handleCheckedBtnChange (value) {
        this.clearCurrentAuth()
        value.map(item => {
          if (this.buttonAuthList.findIndex(_item => _item === item) === -1) this.buttonAuthList.push(item)
        })
        this.checkAllBtn = value.length === this.buttonList.length
      },
      handleNodeClick (data) {
        this.buttonList = this.findBtnList(data.id)
        this.checkedBtnList = []
        this.buttonAuthList.map(item => {
          this.buttonList.map(_item => {
            if (_item.id === item) {
              this.checkedBtnList.push(_item.id)
            }
          })
        })
        this.handleCheckedBtnChange(this.checkedBtnList)
        this.menuTitle = data.name
      },
      findBtnList (id) {
        return this.primaryList.filter(item => item.type === 'BUTTON' && item.parentID === id)
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'handlerRoleManage' && from.name === 'roleManage') {
          this.init()
          this.menuTitle = ''
          this.buttonList = []
          this.confirmButtonAuthList = []
          this.menuAuthList = []
          if (!this.$route.query.id) {
            this.$nextTick(() => {
              this.$refs.handleForm.clearValidate()
              this.$refs.handleForm.resetFields()
            })
          }
        }
      }
    },
    mounted () {
      this.init()
    }
  }
</script>

<style>
  .roleManage .tree-wrap {
    height: 400px;
    min-width: 270px;
    width: 270px;
    overflow-y: scroll;
    display: inline-block;
  }
  .roleManage .check-padding .el-checkbox__label {
    padding-left: 0px;
    padding-right: 10px;
  }
  .roleManage .check-padding .el-checkbox + .el-checkbox {
    margin-left: 0px;
  }
</style>